import { columnKeyMap } from './columnKeyMap';
import { sortTypes } from '../../../../constants/sortTypes';

const {
  address,
  name,
  account,
  accountMark,
  houseType,
  tenantMark,
  aliveClientCount,
  porchCount,
  flatCount,
  clientCount,
  houseStageName,
  flat,
  addressStageName,
  addressStepName,
  addressSaleName,
  flatAcceptanceResult,
  debt,
  immediateRequest,
  activeRequest,
  tenantCount,
  accessType,
  openDate,
  closeDate,
  fio,
  verificationDate,
  isVerified,
  region,
  existLayout,
} = columnKeyMap;

export const sortableColumnsData = {
  [address]: [
    { name: 'streetName', type: sortTypes.string },
    { name: 'building', type: sortTypes.string },
    { name: 'corpus', type: sortTypes.string },
    { name: 'flat', type: sortTypes.string },
  ],
  [region]: [{ name: region, type: sortTypes.number }],
  [name]: [{ name: 'name', type: sortTypes.string }],
  [account]: [{ name: 'account', type: sortTypes.string }],
  [accountMark]: [{ name: 'type.name', type: sortTypes.string }],
  [houseType]: [{ name: 'type.name', type: sortTypes.string }],
  [tenantMark]: [{ name: 'mark', type: sortTypes.string }],
  [aliveClientCount]: [{ name: 'aliveClientCount', type: sortTypes.number }],
  [porchCount]: [{ name: porchCount, type: sortTypes.number }],
  [flatCount]: [{ name: flatCount, type: sortTypes.number }],
  [clientCount]: [{ name: clientCount, type: sortTypes.number }],
  [houseStageName]: [{ name: houseStageName, type: sortTypes.string }],
  [flat]: [{ name: flat, type: sortTypes.string }],
  [addressStageName]: [{ name: addressStageName, type: sortTypes.string }],
  [addressStepName]: [{ name: addressStepName, type: sortTypes.string }],
  [addressSaleName]: [{ name: addressSaleName, type: sortTypes.string }],
  [flatAcceptanceResult]: [
    { name: flatAcceptanceResult, type: sortTypes.string },
  ],
  [debt]: [
    { name: 'existDebt', type: sortTypes.number, invertOrder: true },
    {
      name: 'amount',
      type: sortTypes.number,
      invertOrder: true,
      absValue: true,
    },
  ],
  [immediateRequest]: [
    {
      name: 'immediateRequestCount',
      type: sortTypes.number,
      invertOrder: true,
    },
  ],
  [activeRequest]: [
    {
      name: 'activeRequestCount',
      type: sortTypes.number,
      invertOrder: true,
    },
  ],
  [tenantCount]: [{ name: 'clients', type: sortTypes.arrLength }],
  [accessType]: [{ name: accessType, type: sortTypes.string }],
  [openDate]: [{ name: openDate, type: sortTypes.date }],
  [closeDate]: [{ name: closeDate, type: sortTypes.date }],
  [fio]: [{ name: fio, type: sortTypes.string }],
  [verificationDate]: [{ name: verificationDate, type: sortTypes.date }],
  [isVerified]: [{ name: isVerified, type: sortTypes.string }],
  [existLayout]: [{ name: existLayout, type: sortTypes.string }],
};
